export default __webpack_public_path__ + "static/media/linkDark.79ccff85.svg";